import { Pagination } from "@material-ui/lab";
import { useCallback, useEffect, useState } from "react";

import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { labels } from "resources/resources";
import { PAGINATION } from "utils/const";

import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, makeStyles } from "@material-ui/core";

import componentStylesGeneric from "assets/theme/views/admin/generic";
import TableBackdrop from "components/Backdrops/TableBackdrop/TableBackdrop";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import useQueryParams from "hooks/useQueryParams";
import useTokenHelper from "hooks/useTokenHelper";
import moment from "moment";
import { getFoUSInterventionOtherAreaAction } from "redux/actions/auth/getPersonalInformationAction";

const useStylesGeneric = makeStyles(componentStylesGeneric);

export default function InterventionOtherAreaSection() {
  const classes = useStylesGeneric();
  const intl = useIntl();
  const tokenHelper = useTokenHelper();

  const location = useLocation();
  const { getQueryParams, setQueryParams } = useQueryParams();
  const PAGE_INDEX_KEY = "ioa_pageIndex";

  const [pageIndex, setPageIndex] = useState(() => {
    const params = getQueryParams();
    return params?.[PAGE_INDEX_KEY] || PAGINATION.FIRST_PAGE;
  });

  const dispatch = useDispatch();
  const { getFoUSInterventionOtherArea_result, getFoUSInterventionOtherArea_loading } = useSelector(
    (state) => state.authState
  );

  const tableHead = [
    intl.formatMessage(labels.Label_InterventionOtherArea_Area),
    intl.formatMessage(labels.Label_Date),
    intl.formatMessage(labels.Label_InterventionOtherArea_ReasonForIntervention),
    intl.formatMessage(labels.Label_InterventionOtherArea_Results),
  ];

  const handleChangePage = (_, value) => {
    setPageIndex(value);

    const params = getQueryParams();
    if (value > PAGINATION.FIRST_PAGE) {
      params[PAGE_INDEX_KEY] = value;
    } else {
      delete params[PAGE_INDEX_KEY];
    }
    setQueryParams(params, true);
  };

  useEffect(() => {
    const params = getQueryParams();
    const nextPageIndex = params?.[PAGE_INDEX_KEY] || PAGINATION.FIRST_PAGE;
    if (nextPageIndex !== pageIndex) {
      setPageIndex(nextPageIndex);
    }
  }, [location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  const getData = useCallback(
    (nextPageIndex) => {
      const filter = {
        pageIndex: nextPageIndex,
        pageSize: PAGINATION.PAGE_SIZE,
        userId: tokenHelper.getUserId(),
      };

      dispatch(getFoUSInterventionOtherAreaAction(filter));
    },
    [dispatch, tokenHelper]
  );

  useEffect(() => {
    getData(pageIndex);
  }, [getData, pageIndex]);

  return (
    <CardTableContainer
      title={intl.formatMessage(labels.Label_InterventionOtherArea)}
      count={getFoUSInterventionOtherArea_result?.totalCount}
    >
      <TableContainer>
        <Box component={Table} alignItems="center" marginBottom="0!important">
          <TableHead>
            <TableRow>
              {tableHead.map((prop, key) => (
                <TableCell
                  key={key}
                  classes={{
                    root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                  }}
                >
                  {prop}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {getFoUSInterventionOtherArea_result?.data?.map(
              ({ interventionOtherAreaDescription, date, reasonForIntervention, results, id }) => (
                <TableRow key={id}>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box>{interventionOtherAreaDescription}</Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box>{moment(date).format("DD/MM/YYYY")}</Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box>{reasonForIntervention}</Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box>{results}</Box>
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Box>
        <TableBackdrop open={getFoUSInterventionOtherArea_loading} />
      </TableContainer>

      <Pagination
        className={classes.alignPagination}
        count={getFoUSInterventionOtherArea_result?.totalPages}
        onChange={handleChangePage}
        page={pageIndex}
        color="primary"
      ></Pagination>
    </CardTableContainer>
  );
}
